import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_PAYMENT_TOOLS_URL } from "../constants"
import { IErrorResponse, PaymentToolType, IPageResponse, IPaymentTool } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function fetchPaymentToolsList(
  token: string | null,
  offset: number | undefined,
  limit: number | undefined,
  paymentToolType: PaymentToolType | null
) {
  const response = await axios(
    `${API_PAYMENT_TOOLS_URL}/list/?limit=${limit}&offset=${offset}&paymentToolType=${paymentToolType}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  )

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useGetPaymentToolsList = (offset: number, limit: number, paymentToolType: PaymentToolType | null) => {
  const token = useSelector((state: RootState) => state.auth.token)

  const { data } = useQuery<IPageResponse<IPaymentTool>, IErrorResponse>({
    queryKey: ["payment-tools-list", offset, limit],
    queryFn: () => fetchPaymentToolsList(token, offset, limit, paymentToolType),
    refetchInterval: false,
    refetchOnWindowFocus: false,
  })

  return {
    data,
  }
}
